module.exports = __webpack_public_path__ + "img/emoji-worried-240x240.1fa832a3.png";